import { render, staticRenderFns } from "./ConsignmentAttesterDashboard.vue?vue&type=template&id=2fd00349&scoped=true&"
import script from "./ConsignmentAttesterDashboard.vue?vue&type=script&lang=js&"
export * from "./ConsignmentAttesterDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ConsignmentAttesterDashboard.vue?vue&type=style&index=0&id=2fd00349&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd00349",
  null
  
)

export default component.exports